// extracted by mini-css-extract-plugin
export default {"investmentStage":"InvestmentStage_investmentStage__8KuNl","investmentStage__item":"InvestmentStage_investmentStage__item__QE-9o"};